/* Bluebass : interactions du thème (panier, fiche produit, filtres, guide de sortie) */
(function () {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    const fmt = (window.BB && BB.moneyFormat) || '{{amount_with_comma_separator}} $';
    const n = (cents / 100);
    const avecVirgule = n.toFixed(2).replace('.', ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return Math.round(n).toString();
      if (k === 'amount_with_comma_separator') return avecVirgule;
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(n).toString();
      return n.toFixed(2);
    });
  }

  /* ---------- Couleurs des pastilles ---------- */
  const COULEURS = { rouge: '#c8322b', jaune: '#f2cf2a', blanc: '#f4f4f2', fluo: '#d7f23a', violet: '#6b3fa0', noir: '#1d1d1d', bleu: '#2f73c9', vert: '#3c9a4d', gris: '#9aa3a3', orange: '#f07a24', rose: '#f06aa6', mauve: '#b07cc6', turquoise: '#2cc4c4', transparent: '#e6ecec', transparant: '#e6ecec', flash: '#c7ccd1', 'army green': '#5b6440' };
  function peindrePastilles(scope = document) {
    $$('.couleurs i[data-couleur]', scope).forEach(i => {
      const parts = i.dataset.couleur.toLowerCase().split('/').map(s => s.trim()).filter(Boolean);
      const cols = parts.map(p => COULEURS[p] || '#bbb');
      i.style.background = cols.length > 1 ? `linear-gradient(135deg,${cols[0]} 50%,${cols[1]} 50%)` : cols[0];
    });
  }
  peindrePastilles();

  /* ---------- Menu mobile ---------- */
  const burger = $('#burger');
  if (burger) burger.addEventListener('click', () => {
    const m = $('#menu'); m.classList.toggle('ouvert');
    burger.setAttribute('aria-expanded', m.classList.contains('ouvert'));
  });

  /* ---------- Panier (tiroir) ---------- */
  const tiroir = $('#tiroir'), voile = $('#voile');
  function ouvrir() { if (!tiroir) return; voile.hidden = false; tiroir.hidden = false; }
  function fermer() { if (!tiroir) return; voile.hidden = true; tiroir.hidden = true; }
  async function chargerPanier() {
    const r = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }
  function rendrePanier(cart) {
    $('#nPanier') && ($('#nPanier').textContent = cart.item_count);
    if (!tiroir) return;
    const seuil = (window.BB && +BB.promoSeuil) || 4;
    const n = cart.item_count, reste = seuil - (n % seuil);
    const promo = (window.BB && BB.promoTexte) || '';
    const avantage = (window.BB && BB.promoAvantage) || 'gratuit';
    $('#jauge').innerHTML = (n === 0 ? `Ajoutez ${seuil} articles : le ${seuil}e est ${esc(avantage)}.` :
      reste === seuil ? `<strong>Promo atteinte.</strong> ${esc(promo)}` : `Encore <strong>${reste}</strong> article${reste > 1 ? 's' : ''} et le prochain est ${esc(avantage)}.`)
      + `<div class="barre"><i style="width:${n === 0 ? 0 : ((n % seuil) || seuil) / seuil * 100}%"></i></div>`;
    $('#lignes').innerHTML = cart.items.length ? cart.items.map(it => `
      <div class="ligne-p">
        ${it.image ? `<img src="${esc(it.image)}" alt="">` : '<span></span>'}
        <div class="t">${esc(it.product_title)}<small>${it.variant_title ? esc(it.variant_title) + ' · ' : ''}Qté ${it.quantity} · ${money(it.final_line_price)}</small></div>
        <button type="button" data-retirer="${esc(it.key)}">Retirer</button>
      </div>`).join('') : '<p class="vide-panier">Votre panier est vide.</p>';
    $('#total').textContent = money(cart.total_price);
  }
  document.addEventListener('click', e => {
    const a = e.target.closest('#ouvrirPanier');
    if (a && tiroir) { e.preventDefault(); chargerPanier().then(rendrePanier); ouvrir(); }
  });
  $('#fermerPanier') && $('#fermerPanier').addEventListener('click', fermer);
  voile && voile.addEventListener('click', fermer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') fermer(); });
  $('#lignes') && $('#lignes').addEventListener('click', async e => {
    const b = e.target.closest('[data-retirer]'); if (!b) return;
    const r = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: b.dataset.retirer, quantity: 0 }) });
    rendrePanier(await r.json());
  });

  /* ---------- Fiche produit ---------- */
  const fiche = $('[data-fiche]');
  if (fiche) {
    const produit = JSON.parse($('[data-produit-json]').textContent);
    const form = $('[data-form-produit]', fiche) || $('form[action*="/cart/add"]', fiche);
    const choix = produit.options.map((_, i) => {
      const btn = $(`[data-option="${i}"][aria-pressed="true"]`, fiche);
      return btn ? btn.dataset.valeur : null;
    });
    function majVariante() {
      const v = produit.variants.find(v => v.options.every((o, i) => choix[i] == null || o === choix[i]));
      if (!v) return;
      $('[data-variante]', fiche).value = v.id;
      $('[data-prix]', fiche).innerHTML = money(v.price) + (v.compare_at_price > v.price ? `<s>${money(v.compare_at_price)}</s>` : '');
      const btn = $('[data-ajouter]', fiche);
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      if (v.featured_image && $('#grande')) { $('#grande').srcset = ''; $('#grande').src = v.featured_image.src; }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    }
    fiche.addEventListener('click', e => {
      const t = e.target.closest('button'); if (!t) return;
      if (t.dataset.option != null) {
        choix[+t.dataset.option] = t.dataset.valeur;
        $$(`[data-option="${t.dataset.option}"]`, fiche).forEach(b => b.setAttribute('aria-pressed', b === t));
        majVariante();
      } else if (t.dataset.src) {
        const g = $('#grande'); g.srcset = ''; g.src = t.dataset.src;
        $$('.vignettes button', fiche).forEach(b => b.setAttribute('aria-pressed', b === t));
      } else if (t.dataset.q) {
        const q = $('#qte'); q.value = Math.max(1, (+q.value || 1) + +t.dataset.q);
      }
    });
    if (form && tiroir) form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = $('[data-ajouter]', fiche); btn.disabled = true;
      try {
        const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!r.ok) { const err = await r.json(); alert(err.description || 'Impossible d\'ajouter ce produit.'); return; }
        rendrePanier(await chargerPanier()); ouvrir();
      } finally { btn.disabled = false; majVariante(); }
    });
  }

  /* ---------- Filtres de collection ---------- */
  const coll = $('[data-collection]');
  if (coll) {
    const LEURRES = ['durs', 'surface', 'lames', 'souples'];
    const params = new URLSearchParams(location.search);
    let type = params.get('type') || '', espece = params.get('espece') || '';
    function filtrer() {
      let visibles = 0;
      $$('[data-grille] .carte', coll).forEach(c => {
        const okType = !type || (type === 'leurres' ? LEURRES.includes(c.dataset.type) : c.dataset.type === type);
        const okEsp = !espece || (' ' + c.dataset.especes + ' ').includes(' ' + espece + ' ');
        c.hidden = !(okType && okEsp); if (!c.hidden) visibles++;
      });
      $$('[data-filtre-type]', coll).forEach(b => b.setAttribute('aria-pressed', b.dataset.filtreType === type));
      $$('[data-filtre-espece]', coll).forEach(b => b.setAttribute('aria-pressed', b.dataset.filtreEspece === espece));
      $('[data-aucun]', coll).hidden = visibles > 0;
      const url = new URL(location.href);
      type ? url.searchParams.set('type', type) : url.searchParams.delete('type');
      espece ? url.searchParams.set('espece', espece) : url.searchParams.delete('espece');
      history.replaceState(null, '', url);
    }
    coll.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      if (b.dataset.filtreType != null) { type = b.dataset.filtreType; filtrer(); }
      if (b.dataset.filtreEspece != null) { espece = b.dataset.filtreEspece; filtrer(); }
    });
    filtrer();
  }

  /* ---------- Guide de sortie ---------- */
  const guide = $('[data-guide]');
  if (guide) {
    const P = JSON.parse($('[data-guide-produits]').textContent);
    const R = JSON.parse($('[data-guide-reco]').textContent);
    let esp = 'achigan', sais = 'ete';
    function rendre() {
      const vus = new Set();
      const items = (R[esp] && R[esp][sais] || []).filter(([h]) => P[h] && !vus.has(h) && vus.add(h));
      $('[data-reco]', guide).innerHTML = items.map(([h, why]) => {
        const p = P[h];
        return `<a class="carte" href="${esc(p.u)}">
          <div class="photo">${p.i ? `<img loading="lazy" src="${esc(p.i)}" alt="${esc(p.t)}">` : ''}${p.ok ? '' : '<span class="badge epuise">Épuisé</span>'}${p.b ? `<span class="badge main">${esc(p.b)}</span>` : ''}</div>
          <div class="info"><span class="tag">${esc(p.f)}</span><span class="titre">${esc(p.t)}</span><span class="pourquoi">${esc(why)}</span>
          <div class="bas"><span class="prix">${esc(p.p)}</span></div></div></a>`;
      }).join('') || '<p class="vide-grille">Suggestions à venir pour cette saison.</p>';
      $$('[data-esp]', guide).forEach(b => b.setAttribute('aria-pressed', b.dataset.esp === esp));
      $$('[data-sais]', guide).forEach(b => b.setAttribute('aria-pressed', b.dataset.sais === sais));
    }
    guide.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      if (b.dataset.esp) esp = b.dataset.esp;
      if (b.dataset.sais) sais = b.dataset.sais;
      rendre();
    });
    rendre();
  }
})();
